import { SecondaryColumnHeaderActionsRow, SecondaryColumnHeaderActionButton } from '@/forms-legacy'

import { useApplicationMode } from '@/atoms'
import { Trash, Edit } from '@/icons'

import { useActions } from '../hooks/useActions'
import { useTexts } from '../hooks/useTexts'

interface Props {
  geofence: uui.domain.client.gps.wwgps.Geofence
  view: 'default' | 'delete'
  setView: (view: 'default' | 'delete') => void
}

export function Actions(props: Props) {
  const { geofence, setView } = props
  const [appMode] = useApplicationMode()
  const actions = useActions(geofence, setView)
  const texts = useTexts()

  const readonly = appMode === 'readonly'

  return (
    <SecondaryColumnHeaderActionsRow>
      <SecondaryColumnHeaderActionButton
        label={texts.delete}
        icon={<Trash />}
        onClick={actions.onDelete}
        disabled={readonly}
        testid="geofence-delete"
      />
      <SecondaryColumnHeaderActionButton
        label={texts.edit}
        icon={<Edit />}
        onClick={actions.onEdit}
        disabled={readonly}
        testid="geofence-edit"
      />
    </SecondaryColumnHeaderActionsRow>
  )
}
